export default "__VITE_ASSET__B27X5DSx__"